import api from '../configs/api.config';
import { downloadBlob } from '../helpers/utils';
import { WEFResponse } from '../Types';
import {
  TicketsInJudgmentRequest,
  TicketsInJudgmentResponse
} from '../types/ticketsInJudgment.types';

export const getTicketsInJudgment = async (
  request: TicketsInJudgmentRequest
): Promise<TicketsInJudgmentResponse> => {
  const { data } = await api.post<WEFResponse<TicketsInJudgmentResponse>>(
    '/Analytics/tickets-in-judgment',
    request
  );
  return data.data;
};

export const exportTicketsInJudgment = async (request: TicketsInJudgmentRequest): Promise<void> => {
  const response = await api.post('/Analytics/tickets-in-judgment/export', request, {
    responseType: 'blob'
  });

  const startDate = request.startDate || 'all';
  const endDate = request.endDate || 'all';
  const fileName = `TicketsInJudgment_${startDate}_to_${endDate}.csv`;
  downloadBlob(response.data, fileName);
};
